import React from 'react'

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 3.33301H5.83333V6.66634H2.5V3.33301ZM7.5 4.16634V5.83301H17.5V4.16634H7.5ZM2.5 8.33301H5.83333V11.6663H2.5V8.33301ZM7.5 9.16634V10.833H17.5V9.16634H7.5ZM2.5 13.333H5.83333V16.6663H2.5V13.333ZM7.5 14.1663V15.833H17.5V14.1663H7.5Z" fill="currentColor"/>
  </svg>
)